import { render, staticRenderFns } from "./mainChild.vue?vue&type=template&id=49a0dc28&scoped=true&"
import script from "./mainChild.vue?vue&type=script&lang=js&"
export * from "./mainChild.vue?vue&type=script&lang=js&"
import style0 from "./mainChild.vue?vue&type=style&index=0&id=49a0dc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a0dc28",
  null
  
)

export default component.exports